import { InternalServerErrorException } from '../../../common/exceptions/exceptions';
import { LogManager } from '../../../common/port/log/log.manager.port';
import { GetSelfCallTimeInAppGoalService } from '../../../core/application/services/goals/get-self-call-time-in-app-goal.service';
import { SelfCallTimeInAppGoalEntity } from '../../../core/domain/entities/goals/app-goals/self-call-time-in-app-goal.entity';
import { GetSelfGoalSummaryRequestDto } from '../../dtos/goals/get-self-goal-summaries.request.dto';

export class GetSelfCallTimeInAppGoalQuery {
  constructor(
    protected readonly logManager: LogManager,
    protected readonly service: GetSelfCallTimeInAppGoalService
  ) {}
  async execute(
    props: GetSelfGoalSummaryRequestDto
  ): Promise<SelfCallTimeInAppGoalEntity> {
    try {
      return await this.service.execute(props);
    } catch (error) {
      throw new InternalServerErrorException(error);
    }
  }
}
